import axios, { AxiosResponse } from 'axios';

import { IPrehled } from 'services/akcionar/prehled';

export interface ISezudalosti {
    sezudalosti: IPrehled[];
}

export interface ISeznamNotifikaci {
    typ: 'ZELENE' | 'CERVENE' | 'ZLUTE';
    text: string;
}

const prehledApi = () => {
    return axios({
        method: 'GET',
        url: 'Spravceuctu/Prehled?order=oid:desc'
    }).then((resp: AxiosResponse<ISezudalosti>) => resp.data.sezudalosti);
};
export default prehledApi;
